import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cgw-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrls: ['./modal-alerta.component.scss'],
})
export class ModalAlertaComponent {
  public infoModal = {
    CPUsinGPU: {
      titulo: 'El procesador seleccionado no posee gráficos integrados',
      descripcion: 'Deberás seleccionar una placa de video para que tu computadora sea funcional.',
      botonPrimario: 'aceptar',
      botonSecundario: 'cambiar procesador',
    },
    ARMADOsinGPU: {
      titulo: 'Faltan componentes en la PC seleccionada',
      descripcion:
        'El procesador elegido no tiene gráficos integrados y <span class="font-weight-bold">no seleccionaste una placa de video</span>, por lo que <span class="font-weight-bold">tu PC no tendrá imagen.</span> ¿Querés continuar con tu compra?',
      botonPrimario: 'cambiar componentes',
      botonSecundario: 'entiendo y continuar al pago',
    },
    RESTOGPUCarrito: {
      titulo: 'Faltan componentes en la PC seleccionada',
      descripcion:
        'El procesador elegido no tiene gráficos integrados y <span class="font-weight-bold">no seleccionaste una placa de video</span>, por lo que <span class="font-weight-bold">tu PC no tendrá imagen.</span>',
      botonPrimario: 'aceptar',
      botonSecundario: 'mantener placa de video',
    },
  };
  constructor(
    private matDialogRef: MatDialogRef<ModalAlertaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipo?: string;
      config?: { ocultarBotonPrimario?: boolean; ocultarBotonSecundario?: boolean };
    },
  ) {}

  public close(): void {
    this.matDialogRef.close(false);
  }
}
